import { render, staticRenderFns } from "./CollapseStyles.vue?vue&type=template&id=f264ad56&"
import script from "./CollapseStyles.vue?vue&type=script&lang=js&"
export * from "./CollapseStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports